interface InnovationModalDataInterface {
  [index: number]: {
    [key: string]: {
      title: string
      subtitle: string
      bubbleText: string
      backgroundColor: string
      titleColor: string
      nextPhase: string
      mktEvent: string
      timeline: {
        [key: string]: {
          title: string
        }
      }
      dropdown: {
        [key: string]: {
          title: string
          text: string
          table?: {
            [key: string]: {
              title: string
              [key: string]: string
            }
          }
        }
      }
    }
  }
}

export const InnovationModalData: InnovationModalDataInterface = [
  {
    idea: {
      title: 'Idea',
      subtitle:
        'To go from strategy to idea, you need a cross-functional team to ideate, evaluate and select innovation concepts that hit the brief out of the park.',
      bubbleText: 'Set the stage',
      backgroundColor: '#F4D9FF',
      titleColor: '#AE46D5',
      nextPhase: 'Concept',
      mktEvent: 'pg_act_innovation_innovationprocess_viewidea',
      timeline: {
        faze_1: {
          title: 'Complete Consumer Desirability',
        },
        faze_2: {
          title: 'Complete Financial Viability',
        },
        faze_3: {
          title: 'Complete Technical Feasibility',
        },
        faze_4: {
          title: 'Pipeline Prioritization & Approval',
        },
      },
      dropdown: {
        section_1: {
          title: 'Complete Consumer Desirability',
          text: "Put yourself in the consumer’s place. Is this innovation they didn't even know they needed? The answer must be yes to have a winning idea.",
          table: {
            column1: {
              title: 'Who’s Responsible?',
              row1: 'Human Insights',
            },
            column2: {
              title: 'Key Inputs',
              row1: 'A list of at least ideas to test through.',
              row2: 'Idea description and a representative image for each idea.',
            },
            column3: {
              title: 'Key Outputs / Deliverables',
              row1: 'Proof of consumer desirability for a winning list of ideas ready for Financial Viability and Technical Feasibility assessments',
            },
          },
        },
        section_2: {
          title: 'Complete Financial Viability',
          text: 'Do the numbers add up? Assess the attractiveness of the idea compared with the technical effort required to bring it to life to determine its Financial Viability.',
          table: {
            column1: {
              title: 'Who’s Responsible?',
              row1: 'Finance',
            },
            column2: {
              title: 'Key Inputs',
              row1: 'Clear understanding of definition from each idea.',
            },
            column3: {
              title: 'Key Outputs / Deliverables',
              row1: 'One number score to assess the overall attractiveness of an idea to be compared with the technical effort required to achieve value.',
            },
          },
        },
        section_3: {
          title: 'Complete Technical Feasibility',
          text: 'Technical feasibility defines any obstacles and their complexity on the path to commercializing the innovation.',
          table: {
            column1: {
              title: 'Who’s Responsible?',
              row1: 'Research & Development',
              row2: 'Technical Consumer Research',
              row3: 'Technical Commercialization/Operations',
            },
            column2: {
              title: 'Key Inputs',
              row1: 'Clear understanding of each idea to assess the idea.',
            },
            column3: {
              title: 'Key Outputs / Deliverables',
              row1: 'Completed T-print assessment',
              row2: 'Confirmed T-print Innovation classification',
            },
          },
        },
        section_4: {
          title: 'Pipeline Prioritization & Approval',
          text: 'Before resourcing, projects must be approved by the global innovation teams in marketing and Global Development and Innovation. They make sure the project meets important criteria and opportunities.',
          table: {
            column1: {
              title: 'Who’s Responsible?',
              row1: 'Innovation PMO',
              row2: 'Decision makers may vary by category and OU',
            },
            column2: {
              title: 'Key Inputs',
              row1: 'Data completed in Workfront to      complete gate pre-read',
              row2: 'Present project -recommended decisions, plan and resources required for next stage',
              row3: 'Agree and record Path forward (next gate date)',
            },
            column3: {
              title: 'Key Outputs / Deliverables',
              row1: 'Aligned list of projects to move into resourcing',
              row2: 'Reflect decision and comments in Workfront',
            },
          },
        },
      },
    },
    concept: {
      title: 'Concept',
      subtitle:
        'Here you’ll bring concepts to life and pick the one that passes every test. Get your concept up and running with a business case, project team and launch date.',
      bubbleText: 'Let’s make it IRL',
      backgroundColor: '#FFB1C2',
      titleColor: '#B32347',
      nextPhase: 'Solution',
      mktEvent: 'pg_act_innovation_innovationprocess_viewconcept',
      timeline: {
        faze_1: {
          title: 'Complete Technical<br>Briefs',
        },
        faze_2: {
          title: 'Create Preliminary<br>Business Case',
        },
        faze_3: {
          title: 'Complete Technical<br>Feasibility Risk<br>Assessment',
        },
        faze_4: {
          title: 'Decision to Develop<br>Solutions',
        },
      },
      dropdown: {
        section_1: {
          title: 'Complete Technical Briefs',
          text: 'Complete the technical brief by defining what the innovation tastes and looks like, how it will be packaged to attract attention, and more.',
          table: {
            column1: {
              title: 'Who’s Responsible?',
              row1: 'Initiative Lead',
              row2: 'Technical Commercialization/Operation',
              row3: 'Global Development and Innovation',
            },
            column2: {
              title: 'Key Inputs',
              row1: 'Complete the Technical Brief.',
              row2: 'Share with TI&SC for alignment.',
            },
            column3: {
              title: 'Key Outputs / Deliverables',
              row1: 'Aligned on technical brief with TI&SC',
            },
          },
        },
        section_2: {
          title: 'Create Preliminary Business Case',
          text: 'Give your innovation the best chance to make it through by building a case that leverages preliminary Cost of Goods Sold and assumptions on availability, velocity and cannibalization.',
          table: {
            column1: {
              title: 'Who’s Responsible?',
              row1: 'Finance',
            },
            column2: {
              title: 'Key Inputs',
              row1: 'Confirm capabilities with lead markets and bottlers.',
              row2: 'Define development costs in Workfront.',
              row3: 'Define preliminary TCCS Value Chain for Lead Market and Scale.',
              row4: 'Confirm Value Chain meets thresholds.',
            },
            column3: {
              title: 'Key Outputs / Deliverables',
              row1: 'Preliminary estimates on project’s financial value.',
            },
          },
        },
        section_3: {
          title: 'Complete Technical Feasibility Risk Assessment',
          text: 'Every great leap forward has a measure of risk. It’s time to determine yours. Assess technical risks based on innovation classification and define the probability and impact given the agreed requirements from the Technical Brief.',
          table: {
            column1: {
              title: 'Who’s Responsible?',
              row1: 'TI&SC',
            },
            column2: {
              title: 'Key Inputs',
              row1: 'Completed brief documented definition of done',
              row2: 'Understanding key risks and creating a plan to address them.',
              row3: 'Cross functional team engaged to effectively assess risk',
            },
            column3: {
              title: 'Key Outputs / Deliverables',
              row1: 'Technical / Feasibility risk probability and impact',
              row2: 'Readiness to move to Stage 3',
            },
          },
        },
        section_4: {
          title: 'Decision to Develop Solutions',
          text: 'This is where we’ll use most of our development resources so getting clear on scope, business case and assumptions are critical. This decision-moment brings stakeholders along the journey to open us up to feedback that will give us the best chance for success.',
          table: {
            column1: {
              title: 'Who’s Responsible?',
              row1: 'PMO',
            },
            column2: {
              title: 'Key Inputs',
              row1: 'Data completed in Workfront to complete gate pre-read',
              row2: 'Prepare Gate template',
              row3: 'Agree and record Path forward (next gate date)',
            },
            column3: {
              title: 'Key Outputs / Deliverables',
              row1: 'Alignment to allocate resources to develop solutions',
              row2: 'Clarity on any known risks as part of readiness to proceed',
              row3: 'Reflect decision and comments in Workfront',
            },
          },
        },
      },
    },
    solution: {
      title: 'Solution',
      subtitle:
        'Your solution: be awesome. That’s great, but before your innovation and concept can succeed, you’ll need a solution that goes through many important steps before it makes its debut.',
      bubbleText: 'Prep for success',
      backgroundColor: '#FFD9E1',
      titleColor: '#CB4865',
      nextPhase: 'Launch',
      mktEvent: 'pg_act_innovation_innovationprocess_viewsolution',
      timeline: {
        faze_1: {
          title: 'Test and Validate Solution',
        },
        faze_2: {
          title: 'Complete Technical<br>Feasibility Risk Assessment',
        },
        faze_3: {
          title: 'Decision to Launch',
        },
      },
      dropdown: {
        section_1: {
          title: 'Test and Validate Solution',
          text: "Can your innovation duo, do it? It's time to bring the pieces together and test the full proposition (product and concept) together.",
          table: {
            column1: {
              title: 'Who’s Responsible?',
              row1: 'Initiative Lead',
              row2: 'Human Insights',
            },
            column2: {
              title: 'Key Inputs',
              row1: 'Test and refine proposed solution with consumers based on success criteria.',
              row2: 'Update technical specification.',
              row3: 'Determine appropriate production tests for validation.',
              row4: 'Determine product validation plan and requirements.',
            },
            column3: {
              title: 'Key Outputs / Deliverables',
              row1: 'Learnings to be applied to increase quality of launch and probability of success',
              row2: 'Clarity on how to best position the Bundle with consumers in marketing materials and on shelf (inclusive of VIS, Packaging, Marketing, Merchandising)',
            },
          },
        },
        section_2: {
          title: 'Complete Technical Feasibility Risk Assessment',
          text: 'Stop. Pause. Test. Complete the Technical Feasibility Risk Assessment for Gate 3.',
          table: {
            column1: {
              title: 'Who’s Responsible?',
              row1: 'Research & Development',
              row2: 'Technical Commercialization/Operations',
            },
            column2: {
              title: 'Key Inputs',
              row1: 'Completed brief documented definition of done',
              row2: 'Understanding key risks and creating a plan to address them.',
              row3: 'Cross functional team engaged to effectively assess risk.',
            },
            column3: {
              title: 'Key Outputs / Deliverables',
              row1: 'Technical / Feasibility risk probability and impact',
              row2: 'Readiness to move to Stage 4',
            },
          },
        },
        section_3: {
          title: 'Decision to Launch',
          text: 'Your launch is coming up. Move into final production readiness including procuring graphics and allocating capital.',
          table: {
            column1: {
              title: 'Who’s Responsible?',
              row1: 'PMO',
            },
            column2: {
              title: 'Key Inputs',
              row1: 'Prepare Gate template',
              row2: 'Present project -recommended decisions, plan and resources required for next stage',
              row3: 'Agree and record Path forward (next gate date)',
            },
            column3: {
              title: 'Key Outputs / Deliverables',
              row1: 'Alignment to allocate resources to develop solutions',
              row2: 'Clarity on any known risks as part of readiness to proceed',
              row3: 'Reflect decision and comments in Workfront',
            },
          },
        },
      },
    },
    launch: {
      title: 'Launch Prep',
      subtitle: 'Launch your beverage with marketing, sales, distribution and manufacturing plans in place.',
      bubbleText: '3, 2, 1 blast off!',
      backgroundColor: '#F9B7A9',
      titleColor: '#AA3527',
      nextPhase: 'Market',
      mktEvent: 'pg_act_innovation_innovationprocess_viewlaunchprep',
      timeline: {
        faze_1: {
          title: 'Finalize<br>Production Plan',
        },
        faze_2: {
          title: 'Finalize<br>Distribution Plan',
        },
        faze_3: {
          title: 'Finalize Market<br>Launch Plan',
        },
        faze_4: {
          title: 'Complete<br>Technical<br>Feasibility Risk<br>Assessment',
        },
        faze_5: {
          title: 'Decision to<br>Produce',
        },
      },
      dropdown: {
        section_1: {
          title: 'Finalize Production Plan',
          text: 'Does your innovation have what it needs? Identify supply chain production plan including allocating capital to build new capacity or capabilities.',
          table: {
            column1: {
              title: 'Who’s Responsible?',
              row1: 'Bottler Supply Chain',
              row2: 'Bottler',
            },
            column2: {
              title: 'Key Inputs',
              row1: 'Make capability investments.',
              row2: 'Confirm production sales plan.',
              row3: 'Update or finalize all required forms.',
              row4: 'Implement intellectual property and strategy plans.',
            },
            column3: {
              title: 'Key Outputs / Deliverables',
              row1: 'Confidence in our ability to produce a given innovation.',
            },
          },
        },
        section_2: {
          title: 'Finalize Distribution Plan',
          text: 'Get your innovation into the hands of its drinkers! Identify supply chain distribution plan by understanding transportation implications of getting the innovation from a production facility to a distribution center.',
          table: {
            column1: {
              title: 'Who’s Responsible?',
              row1: 'Bottler Supply Chain',
              row2: 'Bottler',
            },
            column2: {
              title: 'Key Inputs',
              row1: 'Update distribution plan based on bottler demand forecasts.',
              row2: 'Confirm distribution plan.',
              row3: 'Revise and place raw order materials.',
            },
            column3: {
              title: 'Key Outputs / Deliverables',
              row1: 'Confirmation of supply chain distribution capacity as an enabler of commercial success.',
            },
          },
        },
        section_3: {
          title: 'Finalize Market Launch Plan',
          text: 'Let’s get on the same page! Confirmed launch plans with customers, bottlers and marketing to enable in-market success. Feeling the excitement!',
          table: {
            column1: {
              title: 'Who’s Responsible?',
              row1: 'Initiative Lead',
            },
            column2: {
              title: 'Key Inputs',
              row1: 'Customer authorizations.',
              row2: 'Activation of DME levels and media channels for distribution.',
              row3: 'Bottler commitment to production and distribution plans to meet customer demand.',
            },
            column3: {
              title: 'Key Outputs / Deliverables',
              row1: 'Confidence of probability of in-market success.',
            },
          },
        },
        section_4: {
          title: 'Complete Technical Feasibility Risk Assessment',
          text: 'Assess technical risks based on the Innovation classification and define the probability and impact given the agreed requirements from the Technical Brief.',
          table: {
            column1: {
              title: 'Who’s Responsible?',
              row1: 'Research & Development',
              row2: 'Technical Commercialization/Operations',
            },
            column2: {
              title: 'Key Inputs',
              row1: 'Cross functional team engaged to effectively assess risk.',
              row2: 'Understanding key risks and creating a plan to address them.',
              row3: 'Add additional risks, local or by category, that are known at this stage.',
            },
            column3: {
              title: 'Key Outputs / Deliverables',
              row1: 'Technical Feasibility risk probability and impact',
              row2: 'Readiness to move to Stage 5',
            },
          },
        },
        section_5: {
          title: 'Decision to Produce',
          text: 'It’s the last stop before your innovation and concept go out into the world. Deep breath, you got this.',
          table: {
            column1: {
              title: 'Who’s Responsible?',
              row1: 'PMO',
            },
            column2: {
              title: 'Key Inputs',
              row1: 'Prepare Gate template.',
              row2: 'Present project -recommended decisions, plan and resources required for next stage. ',
              row3: 'Agree and record Path forward (next gate date).',
              row4: 'Reflect decision and comments in Workfront.',
            },
            column3: {
              title: 'Key Outputs / Deliverables',
              row1: 'Alignment to allocate resources to launch innovation',
              row2: 'Clarity on any known risks as part of readiness to proceed',
              row3: 'Reflect decision and comments in Workfront',
            },
          },
        },
      },
    },
    market: {
      title: 'Market<br>Execution',
      subtitle:
        'Your idea has launched, but while you celebrate the milestone, it’s also time to measure, optimize as needed to ensure you reach your goals, share results and find potential for scaling.',
      bubbleText: 'Take center stage',
      backgroundColor: '#FFD9E1',
      titleColor: '#CB4865',
      nextPhase: 'Simplify',
      mktEvent: 'pg_act_innovation_innovationprocess_viewmarketexecution',
      timeline: {
        faze_1: {
          title: '3rd Month Tracking',
        },
        faze_2: {
          title: '6th Month Tracking<br>and Review',
        },
        faze_3: {
          title: 'PLR & Decision to Produce',
        },
      },
      dropdown: {
        section_1: {
          title: '3rd Month Tracking',
          text: 'Track post-launch performance of all Innovation on Internal KPIs versus competition on Retail KPIs.',
          table: {
            column1: {
              title: 'Who’s Responsible?',
              row1: 'Marketing Analytics',
            },
            column2: {
              title: 'Key Inputs',
              row1: 'Assess process performance (Stage 0-5) and document learnings.',
              row2: 'Assess process performance (Stage 0-5) and document learnings. Assess 90 days performance at 3rd month mark vs. plan and success.',
            },
            column3: {
              title: 'Key Outputs / Deliverables',
              row1: 'Holistic standardized and efficient Innovation tracking to provide data driven guidance on performance of innovations.',
            },
          },
        },
        section_2: {
          title: '6th Month Tracking and Review',
          text: 'Time for a 6-month check-up. Track post-launch performance of all Innovation on Internal KPIs versus competition on Retail KPIs.',
          table: {
            column1: {
              title: 'Marketing Analytics',
              row1: 'OU/Market Project Lead',
            },
            column2: {
              title: 'Key Inputs',
              row1: 'Assess process performance (Stage 0-5) and document learnings.',
              row2: 'Assess 180 days performance at 6th month mark vs. plan and success.',
            },
            column3: {
              title: 'Key Outputs / Deliverables',
              row1: 'Holistic standardized and efficient Innovation tracking to provide data driven guidance on performance of innovations.',
            },
          },
        },
        section_3: {
          title: 'PLR & Decision to Produce',
          text: 'Are you ready to let your winner sail to new markets? Great innovations should be scaled to more packages within the same market to increase recruitment potential, as well as expanding to new geographies.',
          table: {
            column1: {
              title: 'Who’s Responsible?',
              row1: 'PMO',
            },
            column2: {
              title: 'Key Inputs',
              row1: 'Confirm scale potential',
              row2: 'Document scale up recommendation in Workfront',
              row3: 'Review forecast at PLR',
            },
            column3: {
              title: 'Key Outputs / Deliverables',
              row1: 'Documentation of scale up recommendation in Workfront.',
            },
          },
        },
      },
    },
    simplify: {
      title: 'Simplify for Growth',
      subtitle:
        'Let’s build, build, build. Visuals, video, translations, and anything else we need to make this experience a success, everywhere.',
      bubbleText: 'The makers are busy making',
      backgroundColor: '#FEDEA8',
      titleColor: '#FC4D0F',
      nextPhase: '',
      mktEvent: 'pg_act_innovation_innovationprocess_viewsimplifyforgrowth',
      timeline: {
        faze_1: {
          title: 'Production<br>Alignment',
        },
        faze_2: {
          title: 'Experience Toolkit<br>Production',
        },
        faze_3: {
          title: 'Localization &<br>Clearance',
        },
        faze_4: {
          title: 'Asset Upload &<br>Media Activation',
        },
      },
      dropdown: {
        section_1: {
          title: 'Production Alignment',
          text: 'Efficiency is the name of the game. Co-create and get clearances as needed.',
          table: {
            column1: {
              title: 'Who’s Responsible?',
              row1: 'Project Lead',
              row2: 'Capability Lead(s)',
            },
            column2: {
              title: 'Key Inputs',
              row1: 'Network team (squad) and Studio X to align to maximize efficiencies with co-creation.',
              row2: 'Get Claims and Communications Approval Process (CCAP) clearance with local markets’ regulations.',
            },
            column3: {
              title: 'Key Outputs / Deliverables',
              row1: 'Aligned production schedule',
            },
          },
        },
        section_2: {
          title: 'Experience Toolkit Production',
          text: 'Build out the central assets so the toolkit is fully supported.',
          table: {
            column1: {
              title: 'Who’s Responsible?',
              row1: 'Project Lead',
              row2: 'Capability Lead(s)',
            },
            column2: {
              title: 'Key Inputs',
              row1: 'Network team develops and produces central assets.',
              row2: 'Network team co-creates with Studio X OU team to deliver OU/regional experience toolkits based on matrix plans and local requirements.',
            },
            column3: {
              title: 'Key Outputs / Deliverables',
              row1: 'Experience Toolkit',
              row2: '<b>Decision Moment:</b> Finalized OU/market activation plan',
            },
          },
        },
        section_3: {
          title: 'Localization & Clearance',
          text: 'Studio X customizes and tailors until it’s the perfect fit, wherever the experience lives.',
          table: {
            column1: {
              title: 'Who’s Responsible?',
              row1: 'OU Project Lead',
            },
            column2: {
              title: 'Key Inputs',
              row1: 'Studio X develops market specific executions, assets, translations, transcreation, and adaptation of charter toolkits.',
            },
            column3: {
              title: 'Key Outputs / Deliverables',
              row1: 'Experience Toolkit',
              row2: '<b>Decision Moment:</b> Finalized network assets',
            },
          },
        },
        section_4: {
          title: 'Asset Upload & Media Activation',
          text: 'Upload to KO Assets with the correct project name before the project goes live in market.',
          table: {
            column1: {
              title: 'Who’s Responsible?',
              row1: 'OU Production Lead',
            },
            column2: {
              title: 'Key Inputs',
              row1: 'Upload assets to KO assets with the right project naming',
              row2: 'Project goes live in market',
            },
            column3: {
              title: 'Key Outputs / Deliverables',
              row1: 'All assets uploaded to KO assets',
              row2: 'Project goes live',
            },
          },
        },
      },
    },
  },
]
